var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilmroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.249,
    height: 14,
    viewBox: "0 0 12.249 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-graduate",
    "data-name": "Icon awesome-user-graduate",
    d: "M8.733,8.765,6.125,11.373,3.516,8.765A3.667,3.667,0,0,0,0,12.423v.262A1.313,1.313,0,0,0,1.312,14h9.625a1.313,1.313,0,0,0,1.312-1.312v-.262A3.667,3.667,0,0,0,8.733,8.765ZM.372,2.181l.175.041v1.6A.632.632,0,0,0,.522,4.912L.1,6.616C.049,6.8.153,7,.3,7H1.446c.15,0,.254-.194.208-.383l-.427-1.7A.632.632,0,0,0,1.2,3.819V2.38l1.8.435A3.493,3.493,0,1,0,9.625,4.374a3.437,3.437,0,0,0-.383-1.559l2.633-.634a.435.435,0,0,0,0-.861L6.669.062a2.349,2.349,0,0,0-1.085,0L.372,1.317a.437.437,0,0,0,0,.864Z",
    transform: "translate(0 0.002)",
    fill: "#868686"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilmroom);
export default __webpack_public_path__ + "static/media/filmroom.2cede555e3121e70685061c1f7ca2193.svg";
export { ForwardRef as ReactComponent };